import { expandElement } from '../utils/helper.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class BFGProfileImpactReport extends MainClass {
	private tabs: HTMLElement[];
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.tabs = Array.from( this.selector.querySelectorAll( '.js-impact-report-tab-item' ) ) as HTMLElement[];
		this.selector && this.init();
	}

	handleActiveTab( el: HTMLElement, isClick = false ) {
		const tabLine = this.selector.querySelector( '.tab-side-line' ) as HTMLElement;
		const dataTab = el.getAttribute( 'data-tab' );
		const currentTabContentActive = this.selector.querySelector('.js-impact-report-tab-content.active') as HTMLElement;
		const dataTabContent = this.selector.querySelector( `[data-tab-content="${ dataTab }"]` ) as HTMLElement;
		const topOfContent = this.selector.querySelector('.js-top-of-content') as HTMLElement;
		if (currentTabContentActive && isClick) {
			currentTabContentActive.classList.remove('active')
		}
		if (dataTabContent) {
			dataTabContent.classList.add('active')
		}
		this.tabs.forEach( ( item: HTMLElement ) => {
			item.classList.remove( 'active' );
		} );
		if ( window.matchMedia( '(max-width: 905px)' ).matches ) {
			tabLine.style.width = `${ el.offsetWidth }px`;
			tabLine.style.left = `${ el.offsetLeft }px`;
		} else {
			tabLine.style.height = `${ el.offsetHeight }px`;
			tabLine.style.top = `${ el.offsetTop }px`;
		}

		el.classList.add( 'active' );

		// topOfContent && topOfContent.scrollIntoView( {
		// 	behavior: 'smooth',
		// 	block: 'start',
		// 	inline: 'nearest',
		// } );
	}

	init() {
		if ( this.tabs.length ) {
			this.tabs.forEach( (tab,index) => {
				tab.addEventListener( 'click', () => this.handleActiveTab( tab, true ) );
				setTimeout( () => {
					tab.classList.contains( 'active' ) && this.handleActiveTab( tab );
					if(index === 0){
						tab.click()
					}
				}, 200 );
			} );
		}

		const expandSubImpactBtns = Array.from(this.selector.querySelectorAll('.js-expand-sub-impact-report')) as HTMLElement[];
		if (expandSubImpactBtns.length) {
			expandSubImpactBtns.forEach(item => {
			const wrapperSection = item.closest('.impact-information') as HTMLElement;
            const numberOfRestLocation = item.dataset.numberRestItem;
            const showMoreText = `+ ${numberOfRestLocation} more`;
            item.addEventListener('click', () => expandElement(item, wrapperSection, showMoreText, 'Show less'));
			})
		}
	}
}

export default BFGProfileImpactReport;
